import { render, staticRenderFns } from "./weChatLogin.vue?vue&type=template&id=5f8cb785&scoped=true&"
import script from "./weChatLogin.vue?vue&type=script&lang=js&"
export * from "./weChatLogin.vue?vue&type=script&lang=js&"
import style0 from "./weChatLogin.vue?vue&type=style&index=0&id=5f8cb785&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8cb785",
  null
  
)

export default component.exports